export default __webpack_public_path__ + "static/media/gp-girl.2fb6e035.webp";